





































































































































import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';
import DailyLoadFileStatusIndicator from '@/components/dailyload/dailyloadfilestatusindicator.vue';
import DailyLoadProcessStatusIndicator from '@/components/dailyload/dailyloadprocessstatusindicator.vue';
import { User } from '@/api/user/User';
import LocalDateTime from '@/types/localdatetime';
import UserResource from '@/api/user/UserResource';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { DailyLoadFiStatus } from '@/api/dashboard/DailyLoadFiStatus';
import { DailyLoadFiTableEntry } from '@/api/dashboard/DailyLoadFiTableEntry';
import { DailyLoadFilter } from '@/api/dashboard/DailyLoadFilter';
import { DailyLoadFiStatusResource } from '@/api/dashboard/DailyLoadFiStatusResource';
import IsFederalHolidayResource from '@/api/config/IsFederalHolidayResource';
import { SavedDailyLoadFilterResource } from '@/api/dashboard/SavedDailyLoadFilterResource';
import { Envelope } from '@/types/envelope';
import { DataTablePagingConfig } from '@/types/datatablepagingconfig';
import LocalTimeFormater from '@/util/localtimeformatter';
import DailyLoadSearchFilterForm from '@/components/dailyload/dailyloadsearchfilterform.vue';
import { KCardHeader } from '@kasasa/fbase-components';
import DailyLoadExpectedFilesDialog from '@/components/dailyload/dailyloadexpectedfilesdialog.vue';
import DailyLoadCreateFilterDialog from '@/components/dailyload/dailyloadcreatefilterdialog.vue';
import { DailyLoadExpectedFile } from '@/api/dashboard/DailyLoadExpectedFile';
import { ResourcePagingOptions } from '@/api/resource/ResourcePagingOptions';
import { SavedDailyLoadFilter } from '@/api/dashboard/SavedDailyLoadFilter';
import DailyLoadFilterPicker from '@/components/dailyload/dailyloadfilterpicker.vue';
import UserSelector from '@/components/userselector.vue';
import LocalDateTimeUtils from '@/util/localdatetimeutils';

@Component({
  components: {
    DailyLoadFileStatusIndicator,
    DailyLoadProcessStatusIndicator,
    DailyLoadSearchFilterForm,
    KCardHeader,
    DailyLoadExpectedFilesDialog,
    DailyLoadCreateFilterDialog,
    DailyLoadFilterPicker,
  },
})

export default class ProcessingDashboard extends Vue {
	loading: boolean = true;

	errorMessage:string = '';

	items:DailyLoadFiTableEntry[] = [];

	// pagination options
	totalNumberOfResults:number = 0;

	rowsPerPage:number | null = null;

	currentDisplayedPage:number = 1;

	defaultSortedColumn = 'loadStatus';

	currentlySortedColumn:string = this.defaultSortedColumn;

	sortDirections:string[] = ['DESC', 'ASC'];

	currentlySortedDirection:string = this.sortDirections[0];

	currentDataTablePagingConfig!:DataTablePagingConfig;

	showFilter: boolean = false;

	showCreateFilterDialog: boolean = false;

	expectedFilesDialogOptions = ProcessingDashboard.getClearExpectedFileOptions();

	savedFilters: SavedDailyLoadFilter[] = [];

	selectedFilter: SavedDailyLoadFilter | null = null;

	allUsers: User[] = []

	isYesterdayFederalHoliday: boolean = false;

	initializing: boolean = true;

	headerItems: any = [{
	  text: 'Tech Ops Admin',
	  disabled: false,
	  link: false,
	},
	{
	  text: 'KRP Processing Dashboard',
	  disabled: true,
	}];

	options:any = {};

	footerProps:any = {
	  'items-per-page-options': [25, 50, 100],
	};
	// end of pagination options

	workingFilter:DailyLoadFilter = this.getClearFilter();

	@Inject('DailyLoadFiStatusResource')
	private dailyLoadFiStatusResource!:DailyLoadFiStatusResource;

	@Inject('SavedDailyLoadFilterResource')
	private savedDailyLoadFilterResource!:SavedDailyLoadFilterResource;

	@Inject('UserResource')
	private userResource!: UserResource;

	@Inject('IsFederalHolidayResource')
	private isFederalHolidayResource!:IsFederalHolidayResource;

  processingTableHeaders:any = [
    { text: 'FI ID', value: 'fiId' },
    { text: 'FI Name', value: 'fiName' },
    { text: 'Assigned TE/TSE', value: 'userName' },
    { text: 'Processing Date', value: 'coreProcessingDate', sortable: false },
    { text: 'File Status', value: 'loadStatus' },
    { text: 'Transformation Status', value: 'transformationStatus' },
    { text: 'FIDIL Status', value: 'fidilStatus' },
    { text: 'KRP Status', value: 'krpStatus' },
    { text: 'Drop Date', value: 'dropDate' },
    { text: 'Details', value: 'expectedFiles', sortable: false },
  ];

  mounted() {
    this.loadFilters();
    Promise.all([this.loadUsers(), this.loadIsFederalHoliday()]).finally(() => {
      this.workingFilter = this.getClearFilter();
      this.initializing = false;
      this.resetPageAndApplyFilter();
    });
  }

	@Watch('rowsPerPage')
  rememberRowsPerPage(selectedValue: number) {
	  sessionStorage.setItem(
	    'processtable-rowsPerPage',
	    JSON.stringify(selectedValue),
	  );
	  this.rowsPerPage = selectedValue;
  }

	@Watch('showFilter')
	toggleFilter() {
	  if (!this.showFilter) {
	    this.resetFilters();
	    this.resetPageAndApplyFilter();
	  }
	}

	onWorkingFilterApply() {
	  if (this.hasFilterChanged()) {
	    this.selectedFilter = null;
	  }
	}

	onFilterSelected(savedFilter: SavedDailyLoadFilter) {
	  if (savedFilter) {
	    const filterCopy = { ...savedFilter };
	    filterCopy.filterJson.processingStartDate = this.getStartingRangeDay();
	    filterCopy.filterJson.processingEndDate = ProcessingDashboard.getEndingRangeDay();
	    this.workingFilter = filterCopy.filterJson;
	    this.selectedFilter = savedFilter;
	    this.resetPageAndApplyFilter();
	  }
	}

	onFilterDeleted(deletedFilter: SavedDailyLoadFilter) {
	  this.loading = true;
	  this.loadFilters().finally(() => { this.loading = false; });
	}

	onSortByChange(sortColumnSelected:object) {
	  this.currentlySortedColumn = sortColumnSelected.toString();
	  this.loadProcessTable(this.showFilter);
	}

	onSortDescChange(isSortDesc:object) {
	  this.currentlySortedDirection = (isSortDesc.toString() === 'true')
	  	 ? this.sortDirections[0] : this.sortDirections[1];
	  this.loadProcessTable(this.showFilter);
	}

	onPageChange(eventPageConfig:DataTablePagingConfig) {
	  // if anything changed on the page display values, reload the data
	  if (!this.initializing && this.didPageDisplayConfigChange(eventPageConfig) && this.rowsPerPage) {
	    this.currentDataTablePagingConfig = eventPageConfig;
	    this.loadProcessTable(this.showFilter);
	  }
	}

	onClickExpectedFiles(tableEntry: DailyLoadFiTableEntry) {
	  this.expectedFilesDialogOptions.fiId = tableEntry.fiId;
	  this.expectedFilesDialogOptions.expectedFiles = tableEntry.expectedFiles;
	  this.expectedFilesDialogOptions.coreProcessingDate = tableEntry.coreProcessingDate;
	  this.expectedFilesDialogOptions.fiName = tableEntry.fiName;
	}

	filterSaveInvoked(filter: DailyLoadFilter) {
	  this.workingFilter = filter;
	  this.showCreateFilterDialog	= true;
	}

	onFilterSaved(savedFilter: SavedDailyLoadFilter) {
	  this.showCreateFilterDialog = false;
	  this.workingFilter = savedFilter.filterJson;
	  this.loadFilters().then(() => {
	    this.onWorkingFilterApply();
	    this.resetPageAndApplyFilter();
	  });
	}

	filterApply(filter: DailyLoadFilter) {
	  this.workingFilter = filter;
	  this.onWorkingFilterApply();
	  this.resetPageAndApplyFilter();
	}

	reloadAll() {
	  this.resetPageAndApplyFilter();
	}

	resetPageAndApplyFilter() {
	  if (this.currentDisplayedPage !== 1) {
	    // reset view to page 1, which will automatically reload page
	    this.currentDisplayedPage = 1;
	  } else {
	    this.loadProcessTable(this.showFilter);
	  }
	}

	initializeAndGetRowsPerPage() {
	  if (sessionStorage.getItem('processtable-rowsPerPage')) {
	    this.rowsPerPage = parseInt(
	      `${sessionStorage.getItem('processtable-rowsPerPage')}`,
	      10,
	    );
	  } else {
	    this.rowsPerPage = 25;
	  }
	  return this.rowsPerPage;
	}

	getStartingRangeDay() : number[] {
	  const startingDay: number[] = LocalDateTimeUtils.toDateArray(
	    LocalDateTimeUtils.computeOffsetDaysString(
	      DailyLoadSearchFilterForm.computeStartingDayOffset(this.isYesterdayFederalHoliday),
	    ),
	  )!;
	  return startingDay;
	}

	static getEndingRangeDay() : number[] {
	  const today: number[] = LocalDateTimeUtils.toDateArray(LocalDateTimeUtils.computeOffsetDaysString(0))!;
	  return today;
	}

	loadProcessTable(useFilter: boolean) {
	  this.loading = true;
	  this.errorMessage = '';
	  const requestFilters = useFilter ? this.workingFilter : this.getClearFilter();

	  this.dailyLoadFiStatusResource.getPage(requestFilters, this.getPagingOptions())
	    .then((envelope: Envelope) => {
	      this.totalNumberOfResults = envelope.paging.size;
	      this.resetDataTableEntries(envelope.data);
	      this.loading = false;
	    })
	    .catch((error: any) => {
	      this.showError(error);
	      this.loading = false;
	    });
	}

	async loadFilters(): Promise<SavedDailyLoadFilter[]> {
	  await this.savedDailyLoadFilterResource.getAll().then(
	    (filters: SavedDailyLoadFilter[]) => {
	      this.savedFilters = filters;
	    },
	  )
	    .catch((error: any) => {
	      this.showError(error);
	      this.loading = false;
	    });
	  return this.savedFilters;
	}

	async loadUsers() : Promise<void> {
	  return this.userResource
	    .getAll()
	    .then((result: User[]) => {
	      const filteredUsers : User[] = result.filter(
	        (user: any) => !UserSelector.isEmpty(user.firstName)
						|| !UserSelector.isEmpty(user.lastName),
	      );

	      for (let i = 0; i < filteredUsers.length; i++) {
	        const user: User = filteredUsers[i];
	        user.displayName = UserSelector.getFriendlyDisplayName(
	          user.firstName,
	          user.lastName,
	        );
	      }

	      this.allUsers = filteredUsers;
	    })
	    .catch((error: any) => {
	      console.log(error);
	      this.showError('An unexpected error occurred while attempting to fetch users.');
	    });
	}

	async loadIsFederalHoliday() : Promise<void> {
	  const yesterdayString = LocalDateTimeUtils.computeOffsetDaysString(-1);
	  return this.isFederalHolidayResource
	    .getIsFederalHoliday(yesterdayString)
	    .then((result: boolean) => {
	      this.isYesterdayFederalHoliday = result;
	    })
	    .catch((error:any) => {
	      console.log(error);
	      this.showError('An unexpected error occurred while attempting to fetch federal holidays.');
	    });
	}

	didPageDisplayConfigChange(newPageConfig:DataTablePagingConfig): boolean {
	  if (this.currentDataTablePagingConfig) {
	  return this.currentDataTablePagingConfig.itemsPerPage !== newPageConfig.itemsPerPage
		  || this.currentDataTablePagingConfig.page !== newPageConfig.page;
	  }
	  return true;
	}

	resetFilters() {
	  this.workingFilter = this.getClearFilter();
	  this.selectedFilter = null;
	}

	hasFilterChanged(): boolean {
	  if (!this.selectedFilter) {
	    return false;
	  }

	  const selected = this.selectedFilter.filterJson;
	  const working = this.workingFilter;

	  if (!ProcessingDashboard.isEquivalent(selected.userIds, working.userIds)) {
	    return true;
	  }
	  if (!ProcessingDashboard.isEquivalent(selected.fiIds, working.fiIds)) {
	    return true;
	  }
	  if (selected.unassignedUser !== working.unassignedUser) {
	    return true;
	  }
	  if (selected.dropDateOnly !== working.dropDateOnly) {
	    return true;
	  }
	  if (!ProcessingDashboard.isEquivalentDate(selected.processingStartDate, working.processingStartDate)) {
	    return true;
	  }
	  if (!ProcessingDashboard.isEquivalentDate(selected.processingEndDate, working.processingEndDate)) {
	    return true;
	  }
	  if (!ProcessingDashboard.isEquivalent(selected.transformationStatuses, working.transformationStatuses)) {
	    return true;
	  }
	  if (!ProcessingDashboard.isEquivalent(selected.fidilStatuses, working.fidilStatuses)) {
	    return true;
	  }
	  if (!ProcessingDashboard.isEquivalent(selected.krpStatuses, working.krpStatuses)) {
	    return true;
	  }
	  if (!ProcessingDashboard.isEquivalent(selected.loadStatuses, working.loadStatuses)) {
	    return true;
	  }

	  return false;
	}

	showError(error: any) {
	  if (error.response && error.response.data && error.response.data.entity) {
	    this.setError(error.response.data.entity);
	  } else {
	    this.setError('An unexpected error occurred.');
	  }
	}

	setError(message: string) {
	  const al = new Alert(message, NoticeClass.ERROR);
	  al.setTimeout(5000);
	  this.$store.dispatch('notices/add', al);
	}

	resetDataTableEntries(fiStatuses: DailyLoadFiStatus[]) {
	  this.items = [];
	  for (let i = 0; i < fiStatuses.length; i++) {
	    this.items.push(ProcessingDashboard.buildTableEntry(fiStatuses[i], `${i}`));
	  }
	}

	getPagingOptions() : ResourcePagingOptions {
	  return {
	    pageSize: this.rowsPerPage!,
	    pageIndex: this.currentDisplayedPage - 1,
	    pageSortColumn: this.currentlySortedColumn,
	    pageSortDirection: this.currentlySortedDirection,
	  };
	}

	translateSortColumnName = (columnName: string) => (columnName === 'userName' ? 'userId' : columnName)

	static buildTableEntry(fiStatus: DailyLoadFiStatus, id: string) {
	  const tableEntry: DailyLoadFiTableEntry = {
	    id,
	    fiName: fiStatus.fiName,
	    fiId: fiStatus.fiId,
	    userName: fiStatus.userName,
	    userId: fiStatus.userId,
	    coreProcessingDate: ProcessingDashboard.toDateString(fiStatus.coreProcessingDate),
	    loadStatus: fiStatus.loadStatus,
	    maxExpectedFileDeliveryTime: LocalTimeFormater.toAmPmTimeString(fiStatus.maxExpectedFileDeliveryTime),
	    transformationStatus: fiStatus.transformationStatus,
	    fidilStatus: fiStatus.fidilStatus,
	    krpStatus: fiStatus.krpStatus,
	    dropDate: ProcessingDashboard.toDateString(fiStatus.dropDate),
	    expectedFiles: fiStatus.expectedFiles,
	  };

	  return tableEntry;
	}

	static toDateString(dateParts?: number[]) {
	  return !dateParts ? '' : new LocalDateTime(dateParts).toFriendlyDateString();
	}

	getClearFilter(): DailyLoadFilter {
	  return {
	    userIds: [],
	    fiIds: [],
	    unassignedUser: false,
	    dropDateOnly: false,
	    processingStartDate: this.getStartingRangeDay(),
	    processingEndDate: ProcessingDashboard.getEndingRangeDay(),
	    transformationStatuses: [],
	    fidilStatuses: [],
	    krpStatuses: [],
	    loadStatuses: [],
	  };
	}

	static getClearExpectedFileOptions() {
	  return {
	    expectedFiles: [] as DailyLoadExpectedFile[] | null,
	    fiId: undefined as unknown as number | null,
	    coreProcessingDate: null as string | null,
	    fiName: null as string | null,
	  };
	}

	static isEquivalent(arrayOne : any[], arrayTwo: any[]) : boolean {
	  return JSON.stringify(arrayOne.sort()) === JSON.stringify(arrayTwo.sort());
	}

	static isEquivalentDate(dateOne: number[] | null, dateTwo: number[] | null) : boolean {
	  if (dateOne === null && dateTwo === null) {
	    return true;
	  }

	  if (dateOne === null || dateTwo === null) {
	    return false;
	  }

	  return dateOne[0] === dateTwo[0] && dateOne[1] === dateTwo[1] && dateOne[2] === dateTwo[2];
	}
}
